import React, { forwardRef, useCallback, useState } from 'react';

// GLOBAL VARIABLES
import { APPEND } from 'defaults.js';

// MAIN COMPONENT
export const showButton = Component => forwardRef(({
  showButton,
  ...props
}, ref) => {

  // STATE
  const [ show, setShow ] = useState(!showButton);

  // CALLBACKS
  const handleClick = useCallback(
    () => {
      setShow(!show);
    },
    [show, setShow ]
  )

  // RENDER
  return (
    <Component
      {...props}
      type={show ? props.type : 'password'}
      append={!!showButton ? {
        ...APPEND.showButton,
        onClick: handleClick
      } : props.append}
      ref={ref}
    />
  )
})
